import tokenStore from './token_store'; // @namespace Ajax.Csrf

var Read = /*#__PURE__*/function () {
  function Read(cache, nextAjax) {
    this.ajax = this.ajax.bind(this);
    this.nextAjax = nextAjax;
  }

  var _proto = Read.prototype;

  _proto.ajax = function ajax(options) {
    var jqXHR = this.nextAjax(options);

    if (tokenStore.expectedFor(options.url) && !options.firehose) {
      jqXHR.done(function (data, status, xhr) {
        var tokenHeader = xhr.getResponseHeader('X-CSRF-Token');

        if (tokenHeader) {
          tokenStore.set(options.url, tokenHeader);
        }
      });
    }

    return jqXHR;
  };

  return Read;
}();

export { Read as default };